import { getLayoutObjFromName } from './getLayoutObjFromName';

export const masonryLayoutMode = (layout) => {
  const { view, direction } = getLayoutObjFromName(layout);

  if (view === 'masonry' && direction === 'horizontal') return 'fitRows';
  if (view === 'masonry' && direction === 'vertical') return 'masonry';
  if (view === 'grid') return 'fitRows';
  if (view === 'collage') return 'packery';

  return 'masonry';
};
